import { IDataType, DataType } from '@ecp-caf/common-structure';
import { DtoConstant } from '../gsp-dto-constant';
import { RefTypeEnum } from '../ref-type-enum';

export class DtoStructureReferType extends DataType implements IDataType {
    getKeys(): any[] {
        throw new Error("Method not implemented.");
    }

    getValue(key: any) {
        throw new Error("Method not implemented.");
    }

    constructor(){
      super();
      this.kind=DtoConstant.DTO_STRUCTURED_TYPE_REF;
    }

    /**
     * å¼ç¨çreferçid
     */

    referId: string;
    /**
     * code
     */

    /**
     * å¼ç¨ç±»åï¼åé¨å¼ç¨åå¤é¨å¼ç¨
     */
    referType:RefTypeEnum;

}